/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     NAME: i18next.js
   AUTHOR: Harikrishnan Gangadharan
 COMMENTS: 

/***************************************************************************************************************************
 STANDARD IMPORTS
****************************************************************************************************************************/
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
/***************************************************************************************************************************
 CLASSES / FUNCTIONS
****************************************************************************************************************************/
i18n
.use(Backend)
.use(LanguageDetector)
.use(initReactI18next)
.init({
    react: {
        useSuspense: false
    },
    fallbackLng: "en",
    debug: true,
    interpolation: {
        escapeValue: false,
    }
});

export default i18n;